import classNames from 'classnames'

interface MultiStepProps {
  currentStep: string
  steps: string[]
}

export const MultiStep = ({ steps, currentStep }: MultiStepProps) => {
  const stepsWithoutFinished = steps.filter(step => step !== 'finished')

  return (
    <div
      className={`grid grid-cols-${stepsWithoutFinished.length} gap-x-[0.125rem] px-5 xl:gap-x-1 xl:px-0`}
    >
      {stepsWithoutFinished.map((step, index) => {
        const currentStepIndex = steps.findIndex(item => item === currentStep)
        const isNotCurrentStepAndDifferentLast =
          index < currentStepIndex && index !== stepsWithoutFinished.length - 1

        return (
          <div
            id={
              currentStep === 'resumo' && step === 'resumo'
                ? 'sessao_resumo'
                : ''
            }
            key={index}
            className={isNotCurrentStepAndDifferentLast ? 'opacity-50' : ''}
          >
            <p
              className={classNames(
                'font-myriad text-sm leading-none lg:text-sm lg:leading-none xl:text-xs xl:leading-none 1.5xl:text-sm 1.5xl:leading-none text-center uppercase',
                {
                  'text-orange':
                    step === currentStep || index < currentStepIndex,
                  'text-v3-gray-275': index > currentStepIndex
                }
              )}
            >
              {step}
            </p>

            <div
              className={classNames(
                'w-full h-[5px] mt-0.5 rounded-[5px] lg:h-[5px] xl:h-0.5 1.5xl:h-[5px]',
                {
                  'bg-orange': step === currentStep || index < currentStepIndex,
                  'bg-v3-gray-275': index > currentStepIndex
                }
              )}
            />
          </div>
        )
      })}
    </div>
  )
}
